import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import { VImage } from "../../style/base.style";
import { breadcrumb_bg_01, breadcrumb_bg_02, breadcrumb_icon } from "../../constants/images";
import { BreadCrumb } from "../../components/common/breadcrumb";
import { useDictionary } from "../../contexts/dictionary";

const Contactus = () => {
  const {translate} = useDictionary()
  return (
    <>
      <Header/>

      <>
        <>
          {/* Breadcrumb */}
          <BreadCrumb title={translate('contact_us')} />
          {/* /Breadcrumb */}
        </>

        <>
          {/* Contact Us */}
          <section className="contact-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <div className="section-inner-header contact-inner-header">
                    <h6>{translate('get_in_touch')}</h6>
                    <h2>{translate('have_any_questions')}</h2>
                  </div>
                  <div className="card contact-card">
                    <div className="card-body">
                      <div className="contact-icon">
                        <i className="isax isax-location5" />
                      </div>
                      <div className="contact-details">
                        <h4>{translate('address_label')}</h4>
                        <p>{translate('address')}</p>
                      </div>
                    </div>
                  </div>
                  <div className="card contact-card">
                    <div className="card-body">
                      <div className="contact-icon">
                        <i className="isax isax-call5" />
                      </div>
                      <div className="contact-details">
                        <h4>{translate('phone_label')}</h4>
                        <p>{translate('phone')}</p>
                      </div>
                    </div>
                  </div>
                  <div className="card contact-card">
                    <div className="card-body">
                      <div className="contact-icon">
                        <i className="isax isax-sms5" />
                      </div>
                      <div className="contact-details">
                        <h4>{translate('email_label')}</h4>
                        <p>{translate('email')}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-12 d-flex">
               
                </div>
              </div>
            </div>
          </section>
          {/* /Contact Us */}
        </>

        {/* Contact Map */}
        <section className="contact-map d-flex">
          <iframe
            src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=he&amp;coord=32.0902142, 34.8577231&amp;q=1%20Totseret+ha-Arets+St+3,+Petah+Tikva%2C%20Israel&amp;ie=UTF8&amp;t=&amp;z=15&amp;iwloc=B&amp;output=embed"
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </section>
        {/* /Contact Map */}
      </>
      <Footer />
    </>
  );
};

export default Contactus;
